import { PaymentOrchestrationError } from "./PaymentOrchestrationError";
import { PaymentErrorCategories } from "./PaymentErrorCategories";

/**
 * Error thrown when payment processing fails.
 * This includes payment declined, insufficient funds, card issues, network failures, API timeouts, etc.
 * Usually recoverable by trying a different payment method or retrying.
 */
export class PaymentProcessingError extends PaymentOrchestrationError {
  readonly category = PaymentErrorCategories.PROCESSING;
  readonly recoverable = false;

  constructor(
    technicalMessage: string,
    options?: {
      userMessage?: string;
      metadata?: Record<string, unknown>;
    }
  ) {
    super(technicalMessage, {
      userMessage:
        options?.userMessage ||
        "Your payment could not be processed. Please try again or contact support.",
      metadata: options?.metadata,
    });
  }
}
